import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { SmartphoneCollectService } from '../../../../services/api-appointment/smartphone-collect/smartphone-collect.service';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import {  NgbDate ,  NgbCalendar ,  NgbDateParserFormatter ,  NgbDateStruct ,  NgbModal  } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SmartphoneCollectRequestExportCSV, SmartphoneCollectRequestSearch, SmartphoneCollectStatus } from '../../../../models/api-appointment/smartphone-collect/smartphone-collect.request.model';
import { ActionConfirmComponent } from '../../../../components/ui/actionconfirm/actionconfirm.component';
import { ActionConfirmModel } from '../../../../models/action-confirm.model';
import { DIALOG_MEDIUM_CONFIG } from '../../../../utils/config/modal-settings';
import { TRUE } from '../../../../utils/config/const';
import { User } from '../../../../models/user';

@Component({
  selector: 'app-smartphone',
  templateUrl: './smartphone.component.html',
  styleUrls: ['./smartphone.component.css']
})
export class SmartphoneComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  currentUser: User;
  searchFilterForm: FormGroup;
  hoveredDate: NgbDate | null = null;
  fromDate: any
  toDate: any
  convertedFromDate: any;
  convertedToDate: any;
  storeCity = '';
  isTargetMailList: boolean = false;
  status = [];
  storeAddress = '';
  request: any = {};
  exportDivOpen: boolean = false;
  statusSettings = {};
  statusList = [
    { value: 'TUTTI' },
    { value: SmartphoneCollectStatus.CONFIRMED },
    { value: SmartphoneCollectStatus.COMPLETED, },
  ];
  maxDate: NgbDateStruct;
  public isEmpty: boolean = false;
  public isSearching: boolean = false;


  constructor(
    private authenticationService: AuthenticationService,
    private SmartphoneCollectService: SmartphoneCollectService,
    private domSanitizer: DomSanitizer,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private toastr: ToastrService,
    private router: Router,
    public modalService: NgbModal
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: '',
      searchFilterField_completedOldValue: '',
      searchFilterField_completed: '',
      searchFilterField_reservedOldValue: '',
      searchFilterField_reserved: '',
      searchFilterField_reservedCheck: false,
      searchFilterField_completedCheck: false,
    });
    this.getDefaultDate();
    this.getDefaultStatus();
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  _statusSettings() {
    return {
      singleSelection: true,
      enableCheckAll: false,
      primaryKey: 'value',
      labelKey: 'value',
      searchBy: ['value'],
      showCheckbox: window.name,
      classes: 'form-control sim-select',
      lazyLoading: false,
      text: 'Seleziona stato appuntamento',
      noDataLabel: 'Nessuna risultato con la ricerca associata',
      searchAutofocus: true,
      badgeShowLimit: 4,
      autoPosition: false
    };
  };

  /**
* Inizializza la tabella
*/
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      {orderable: false,targets: 0,width:'15%'},
      {orderable: false,targets: 1,width:'15%'},
      {orderable: false,targets: 2,width:'15%'},
      {orderable: false,targets: 3,width:'15%'},
      {orderable: false,targets: 4,width:'15%'},
      {orderable: false,targets: 5,width:'15%'},
      {orderable: false,targets: 6,width:'5%'}
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;
      
      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      that.dimPagina = dataTablesParameters.length;
      let smartphoneCollectRequestSearch = that.getFilter();
      that.SmartphoneCollectService.search(smartphoneCollectRequestSearch).subscribe(
        (response) => {
          if(response != null && typeof response != typeof undefined){
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          }else{
            this.isEmpty = false;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    }
  }

  ngOnInit() {
    
    this.initTable();
    this.getSettings();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /**
  * Click sulla lente per la ricerca
  */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }


  filterReserved() {
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_reserved.value);
    this.resetFilter();
    this.ajaxReload();
  }

  filterAppointment() {
    this.searchFilterForm.controls.searchFilterField_completedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_completed.value);
    this.resetFilter();
    this.ajaxReload();
  }

  toggleCheckBoxes(elementToToggle) {
    let value = this.searchFilterForm.controls[elementToToggle].value
    this.searchFilterForm.controls[elementToToggle].setValue(!value);
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.value !== elementToToggle && item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
      if (i === listOfCheckboxes.length - 1) {
        this.changeFilter();
      }
    })
  }


  /**
   * Chiamata quando cambia un valore dei filtri
   */
  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.searchFilterForm.controls.searchFilterField_reserved.setValue(this.searchFilterForm.controls.searchFilterField_reservedOldValue.value);
    this.searchFilterForm.controls.searchFilterField_completed.setValue(this.searchFilterForm.controls.searchFilterField_completedOldValue.value);
    this.resetFilter();
    this.ajaxReload();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let smartphoneCollectRequestSearch = new SmartphoneCollectRequestSearch();
    // Search Bar
    smartphoneCollectRequestSearch.q = this.searchFilterForm.controls['searchFilterField'].value;
    // Page Number
    smartphoneCollectRequestSearch.pageNumber = this.numeroPagina;
    // Page Size
    smartphoneCollectRequestSearch.pageSize = this.dimPagina;
    // Date Filter
    smartphoneCollectRequestSearch.reservationDate = this.searchFilterForm.controls['searchFilterField_reserved'].value;
    smartphoneCollectRequestSearch.appointmentDate = this.searchFilterForm.controls['searchFilterField_completed'].value;
    // Checkboxes
    if (this.searchFilterForm.controls['searchFilterField_completedCheck'].value == TRUE) {
      smartphoneCollectRequestSearch.appointmentStatus = SmartphoneCollectStatus.COMPLETED;
    }
    if (this.searchFilterForm.controls['searchFilterField_reservedCheck'].value == TRUE) {
      smartphoneCollectRequestSearch.appointmentStatus = SmartphoneCollectStatus.CONFIRMED;
    }
    return smartphoneCollectRequestSearch;
  }

  clickButtonClearFilter() {
    // Search
    this.searchFilterForm.controls.searchFilterField.setValue('');
    // Date
    this.searchFilterForm.controls.searchFilterField_reserved.setValue('');
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue('');
    this.searchFilterForm.controls.searchFilterField_completed.setValue('');
    this.searchFilterForm.controls.searchFilterField_completedOldValue.setValue('');
    // Checkboxes
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
    })
    this.clickSearch();
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  convertDate() {
    if (this.fromDate.month < 10) {
      this.fromDate.month = '0' + this.fromDate.month;
    }
    if (this.fromDate.day < 10) {
      this.fromDate.day = '0' + this.fromDate.day;
    }
    if (this.toDate.month < 10) {
      this.toDate.month = '0' + this.toDate.month;
    }
    if (this.toDate.day < 10) {
      this.toDate.day = '0' + this.toDate.day;
    }
    this.convertedFromDate = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.convertedToDate = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
  }

  openExportDiv() {
    this.exportDivOpen = !this.exportDivOpen;
  }

  clickButtonUpdate(id) {
    const url = 'clickandcollect/smartphone/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }

  getDateRange(range) {
    if (range == 'month') {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 30);
      this.toDate = this.calendar.getToday();
    } else {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
      this.toDate = this.calendar.getToday();
    }
  }

  getValue() {
    this.convertDate();
    let request = new SmartphoneCollectRequestExportCSV();
    request.appointmentDateFrom = this.convertedFromDate;
    request.appointmentDateTo = this.convertedToDate;
    request.isTargetMailList = this.isTargetMailList;
    if (this.status[0].value != 'TUTTI') {
      request.status = this.status[0].value;
    }
    if (this.storeAddress != '') {
      request.q = this.storeAddress;
    }
    return request;
  }

  getSettings() {
    this.statusSettings = this._statusSettings();
  }

  getDefaultDate() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
    this.toDate = this.calendar.getToday();
    this.maxDate = { year: this.toDate.year, month: this.toDate.month, day: this.toDate.day };
  }

  getDefaultStatus() {
    this.status = [];
    this.status.push(this.statusList[0]);
  }

  resetForm() {
    this.getDefaultStatus();
    this.getDateRange('month');
    this.storeAddress = '';
    this.storeCity = '';
    this.isTargetMailList = false;
  }

  clickButtonDelete(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare la prenotazione?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.delete(id);
        }
      }
    }, (error) => {
      console.log(error);
    });
  }

  /**
* 
* @param id Delete
*/
  delete(id) {
    this.SmartphoneCollectService.delete(id)
      .subscribe(
        (response: any) => {
          //Aggiorna tabella
          this.ajaxReload();
          //Togli spinner
          this.spinner.hide();
          //Feedback all'utente
          this.toastr.success('Prenotazione cancellata con successo', 'Cancella prenotazione');
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.spinner.hide();
          this.toastr.error('Si è verificato un errore durante la cancellazione della prenotazione', 'Cancella prenotazione fallita', {
            timeOut: 5000
          });
        }
      );
  }

  save() {
    this.request = this.getValue();
    this.SmartphoneCollectService.exportCSV(this.request).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.toastr.success('Export creato con successo', 'Crea Export', {
            timeOut: 5000
          });
          this.openExportDiv();
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante l\'Export', 'Crea Export', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }
  
  get userRole() {
    let res = "";
    for (let i = 0; i < this.currentUser.userBackend.authorities.length && res == ""; i++) {
      if (this.currentUser.userBackend.authorities[i].authority.startsWith("ROLE_")) {
        res = this.currentUser.userBackend.authorities[i].authority;
      }
    }
    console.log(res);
    return res;
  }

}
